import React, { useState, useEffect } from "react";
import { Modal, Button, Form, InputGroup } from "react-bootstrap";
import { useCreateCustomPlan } from "../../hooks/useCreateCustomPlan";
import { useUpdateCustomPlan } from "../../hooks/useUpdateCustomPlan";

const CustomPlanModal = ({ show, onHide, companyId, existingPlan = null }) => {
  const [basePrice, setBasePrice] = useState("");
  const [pricePerAdditionalUser, setPricePerAdditionalUser] = useState("");
  const [baseplanUsers, setBaseplanUsers] = useState("");
  const [notes, setNotes] = useState("");

  const { mutate: createPlan, isPending: isCreating } = useCreateCustomPlan();
  const { mutate: updatePlan, isPending: isUpdating } = useUpdateCustomPlan();

  const isEditMode = !!existingPlan;
  const isPending = isCreating || isUpdating;

  useEffect(() => {
    if (existingPlan) {
      setBasePrice(existingPlan.basePrice || "");
      setPricePerAdditionalUser(existingPlan.pricePerAdditionalUser || "");
      setBaseplanUsers(existingPlan.baseplanUsers || "");
      setNotes(existingPlan.customPlanNotes || "");
    } else {
      setBasePrice("");
      setPricePerAdditionalUser("");
      setBaseplanUsers("");
      setNotes("");
    }
  }, [existingPlan, show]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!basePrice || basePrice <= 0) {
      return;
    }

    const body = {
      basePrice: parseFloat(basePrice),
      ...(pricePerAdditionalUser && { pricePerAdditionalUser: parseFloat(pricePerAdditionalUser) }),
      ...(baseplanUsers && { baseplanUsers: parseInt(baseplanUsers) }),
      ...(notes && { notes }),
    };

    if (isEditMode) {
      updatePlan(
        { companyId, body },
        {
          onSuccess: () => {
            onHide();
          },
        }
      );
    } else {
      createPlan(
        { companyId, body },
        {
          onSuccess: () => {
            onHide();
          },
        }
      );
    }
  };

  const handleClose = () => {
    setBasePrice("");
    setPricePerAdditionalUser("");
    setBaseplanUsers("");
    setNotes("");
    onHide();
  };

  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>{isEditMode ? "Edit Custom Plan" : "Create Custom Plan"}</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Base Price *</Form.Label>
            <InputGroup>
              <InputGroup.Text>$</InputGroup.Text>
            <Form.Control
              type="number"
              step="0.01"
              min="0"
              value={basePrice}
              onChange={(e) => setBasePrice(e.target.value)}
              required
              placeholder="Enter base monthly price"
            />
            </InputGroup>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Price Per Additional User</Form.Label>
            <InputGroup>
              <InputGroup.Text>$</InputGroup.Text>
            <Form.Control
              type="number"
              step="0.01"
              min="0"
              value={pricePerAdditionalUser}
              onChange={(e) => setPricePerAdditionalUser(e.target.value)}
              placeholder="Enter price per additional user"
            />
            </InputGroup>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Base Plan Users</Form.Label>
            <Form.Control
              type="number"
              min="0"
              value={baseplanUsers}
              onChange={(e) => setBaseplanUsers(e.target.value)}
              placeholder="Enter number of base plan users"
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Notes</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              placeholder="Add notes about this custom plan"
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose} disabled={isPending}>
            Cancel
          </Button>
          <Button variant="primary" type="submit" disabled={isPending || !basePrice || basePrice <= 0}>
            {isPending ? (isEditMode ? "Updating..." : "Creating...") : isEditMode ? "Update Plan" : "Create Plan"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default CustomPlanModal;

